module.exports = __webpack_public_path__ + "static/media/Madfit_Website_12.7630f80d.jpg";